import {UcoastEl} from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

// note to new dev team: this was from a different team who isn't familiar with typescript. refactor/cleanup is recommended

export class ValueProps extends UcoastEl {
  static htmlSelector = 'value-props'

  buttons: NodeListOf<HTMLElement>
  items: NodeListOf<HTMLElement>
  slider: HTMLElement
  interval: number

  constructor() {
    super()

    this.buttons = q.rl('[data-uc-value-props-button]', this)
    this.items = q.rl('[data-uc-value-props-item]', this)
    this.slider = q.rs('[data-uc-value-props-slider]', this)

    this.buttons.forEach(button =>
      button.addEventListener('click', this.activate.bind(this))
    )

    this.interval = setInterval(() => {
      this.next()
    }, 5000)
  }

  toggle(index: number) {
    this.buttons.forEach((button, key) => {
      button.classList.toggle('active', key === index)
    })

    this.items.forEach((item, key) => {
      item.classList.toggle('active', key === index)

      if (key === index) {
        this.slider.style.minHeight = `${item.scrollHeight}px`
        item.style.minHeight = `${item.scrollHeight}px`
      } else {
        item.style.minHeight = `0px`
      }
    })
  }

  activate(event: Event) {
    const target = q.rt<Event, HTMLButtonElement>(event)

    const index = +q.oa(target, 'data-uc-value-props-button')

    this.toggle(index)

    clearInterval(this.interval)

    this.interval = setInterval(() => {
      this.next()
    }, 5000)
  }

  next() {
    let index

    this.buttons.forEach((button, key) => {
      if (button.classList.contains('active')) {
        index = key
      }
    })

    if (this.items.length - 1 === index) {
      index = 0
    } else {
      index++
    }

    this.toggle(index)
  }
}
